// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"e3f3ff7a61e0c7a5d812","303":"b9c32456b1be093a75f9","495":"67b17d8b94a0aef8ab6f"}[chunkId] + ".js";
};